'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalShodoSignRequest(origin, nomeAlgoritmo, textos) {
  this.wB = null;
  this.Jj = null;
  this.Jk = null;
  this.wB = origin;
  this.Jj = nomeAlgoritmo;
  this.Jk = textos;
}
export { $c_Lpresto_AgentView$LocalShodoSignRequest as $c_Lpresto_AgentView$LocalShodoSignRequest };
$p = $c_Lpresto_AgentView$LocalShodoSignRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalShodoSignRequest;
/** @constructor */
function $h_Lpresto_AgentView$LocalShodoSignRequest() {
}
export { $h_Lpresto_AgentView$LocalShodoSignRequest as $h_Lpresto_AgentView$LocalShodoSignRequest };
$h_Lpresto_AgentView$LocalShodoSignRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalShodoSignRequest)) {
    if (((this.wB === x$0.wB) && (this.Jj === x$0.Jj))) {
      var x = this.Jk;
      var x$2 = x$0.Jk;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "LocalShodoSignRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.wB;
      break;
    }
    case 1: {
      return this.Jj;
      break;
    }
    case 2: {
      return this.Jk;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.pm = (function() {
  return this.wB;
});
function $isArrayOf_Lpresto_AgentView$LocalShodoSignRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hJ)));
}
export { $isArrayOf_Lpresto_AgentView$LocalShodoSignRequest as $isArrayOf_Lpresto_AgentView$LocalShodoSignRequest };
var $d_Lpresto_AgentView$LocalShodoSignRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalShodoSignRequest, "presto.AgentView$LocalShodoSignRequest", ({
  hJ: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalShodoSignRequest as $d_Lpresto_AgentView$LocalShodoSignRequest };
//# sourceMappingURL=presto.-Agent-View$-Local-Shodo-Sign-Request.js.map
